import { Button } from '@/components/atoms'
import { reportingSearchSchema } from '@/schemas'
import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const ReportRestrictedContent = () => {
    const { t } = useTranslation('translations')
    const navigate = useNavigate()

    return (
        <div className="grid h-full w-full place-items-center">
            <div className="space-y-6">
                <div className="space-y-2 text-center text-sm text-subtle">
                    <img
                        src="/assets/restricted-illustration.svg"
                        alt="Restricted Access"
                        className="mx-auto"
                    />
                    <h2 className="text-heading-6">
                        {t('reports.reportRestricted.title')}
                    </h2>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: t('reports.reportRestricted.description'),
                        }}
                    />
                </div>
                <div className="space-y-4">
                    <Button
                        onClick={() => {
                            void navigate({
                                to: '/reporting',
                                search: reportingSearchSchema.parse({}),
                            })
                        }}
                        name={'report-restricted-go-to-reporting-button'}
                        size="xlarge"
                        variant="outlinePrimary"
                        className="mx-auto"
                    >
                        {t('reports.reportRestricted.goToReporting')}
                    </Button>
                    <Button
                        onClick={() => {
                            void navigate({ to: '/dashboard' })
                        }}
                        name={'report-restricted-go-to-dashboard-button'}
                        size="xlarge"
                        className="mx-auto"
                    >
                        {t('reports.reportRestricted.goToDashboard')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
